import { Fn } from '@/types/common';
import { equals } from '@/utils/common';

export const getUrlAnchor = (url: string) => {
  const anchorIndex = url.indexOf('#');
  if (equals(anchorIndex, -1)) return '';
  return url.slice(anchorIndex, url.length);
};

export const removeAnchorFromUrlString = (url: string) => {
  const anchor = getUrlAnchor(url);
  if (anchor) return url.replace(anchor, '');
  return url;
};

export const scrollToAnchor = (elementID: string, onSuccessScroll?: Fn<number, void>) => {
  const el = document.getElementById(elementID);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    onSuccessScroll?.(Date.now());
  }
};
